import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { isNativeApp } from './features/location/native-bridge';
import './index.css';

// Lets the stylesheet keep the topbar and the composer clear of the phone's
// status and navigation bars, which the Android shell draws the page under.
// A browser tab never gets this class, and its insets stay zero.
if (isNativeApp()) document.documentElement.classList.add('in-shell');

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
